import { Map, fromJS } from 'immutable';
import * as actions from '../utils/Constants'
import * as moment from 'moment';

export default (state = getInitialState(), action) => {
    switch (action.type) {
        case actions.NEW_SESSION:
            {
                return getInitialState();
            }
        case actions.GET_SESSION + actions.FULFILLED:
            {
                return fromJS(action.payload);
            }
        case actions.SAVE_SESSION + actions.FULFILLED:
            {
                return fromJS(action.payload);
            }
        case actions.UPDATE_SESSION:
            {
                return state.set(action.payload.field, action.payload.value)
            }
        default:
            return state;
    }
}

const getInitialState = () => {
    return Map({
        year: moment().year(),
        isActive: true
    });
}